import { fromJS, List, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { DurationPerMonthFilter } from './duration-per-month-filter.model';

export const ALL_YEARS: number = -1;
export const DURATION_PER_YEAR_FILTER_SCHEMA = Object.freeze({
  YEAR: ALL_YEARS, // calendar-year
  COUNT: 0,
  MONTHS: List<DurationPerMonthFilter>([]),
});
const RECORD = generateSchema(DURATION_PER_YEAR_FILTER_SCHEMA);
const KEYS: any = generateKeys(DURATION_PER_YEAR_FILTER_SCHEMA);

export class DurationPerYearFilter extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    return setInModel(this, [
      {
        key: KEYS.MONTHS,
        value: props.get(KEYS.MONTHS)
          ? this.months.map((params) => new DurationPerMonthFilter(params))
          : List<DurationPerMonthFilter>([]),
      },
    ]) as DurationPerYearFilter;
  }

  get year(): number {
    return this.get(KEYS.YEAR);
  }

  // naming appointmentsCount() so it doesn't override Map.count()
  get appointmentsCount(): number {
    return this.get(KEYS.COUNT);
  }

  get months(): List<DurationPerMonthFilter> {
    return this.get(KEYS.MONTHS);
  }

  isAllYears(): boolean {
    return this.year === ALL_YEARS;
  }
}
